import {
  UPDATE_PARAMS,
  SET_ATTRIBUTES,
  SET_PRODUCT_DATA,
  SET_PREVIEW_LOADING,
  SET_INFO_NOTICE_WAS_SHOWN,
} from "../actions";

import { normalizeAttrsParams } from "../../helpers/attributes";
import { getTotalPrice } from "../../helpers/price";
import { getPreviewImage } from "../../helpers/previewImage";

export default function reducer(state = [], action) {
  switch (action.type) {
    case SET_ATTRIBUTES:
      return {
        ...state,
        attributes: action.data,
      };

    case UPDATE_PARAMS:
      let { params, forceUpdate } = action.data;
      let touchedAttributes = state.touchedAttributes;

      if (!forceUpdate) {
        touchedAttributes = [...touchedAttributes, ...Object.keys(params)];

        params = {
          ...state.params,
          ...params,
        };
      }

      params = normalizeAttrsParams(
        state.attributes,
        params,
        touchedAttributes
      );

      return {
        ...state,
        params,
        totalPrice: getTotalPrice(params),
        previewImage: getPreviewImage(params),
        touchedAttributes: touchedAttributes,
      };

    case SET_PRODUCT_DATA:
      return {
        ...state,
        productData: action.data,
      };

    case SET_PREVIEW_LOADING:
      return {
        ...state,
        previewLoading: !!action.data,
      };

    case SET_INFO_NOTICE_WAS_SHOWN:
      return {
        ...state,
        infoNoticeWasShown: true,
      };

    default:
      return state;
  }
}
